import type React from 'react';
import cx from 'classnames';
import './style.scss';

type Props = {
  type: 'bar' | 'line' | 'box' | 'badge';
  cover?: boolean;
  dark: boolean;
  className: string;
};

const Bone: React.FC<React.PropsWithChildren<Props>> = ({ dark = false, type = 'line', cover, className }) => (
  <div
    className={cx(`Bone Bone-${type}`, className, {
      'Bone-cover': cover,
      'Bone-light': !dark,
      'Bone-dark': dark,
    })}
  />
);

export default Bone;
